"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchandiseEditionSelector = exports.merchUnitTypeSelector = exports.baseMerchForAdditionalUnitSelector = exports.isGrowthSuiteSelector = exports.getMerchIdForEditionSelector = exports.merchandiseSelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reselect = require("reselect");

var _SubscriptionTermSelectors = require("./SubscriptionTermSelectors");

var _Hubs = require("self-service-api/constants/Hubs");

var _Editions = require("self-service-api/constants/Editions");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _HubTypes = _interopRequireDefault(require("self-service-api/constants/HubTypes"));

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var merchandiseSelector = function merchandiseSelector(_ref) {
  var merchandise = _ref.merchandise;
  return merchandise;
};

exports.merchandiseSelector = merchandiseSelector;
var getMerchIdForEditionSelector = (0, _reselect.createSelector)(_SubscriptionTermSelectors.subscriptionTermsSelector, merchandiseSelector, _MarketingContactsSelectors.isInMCBetaSelector, function (subscriptionTerms, merchandiseMap, isInMCBeta) {
  return function (hub, edition) {
    var isMarketingStarter = hub === _Hubs.HUB_MARKETING && edition === _Editions.STARTER;
    var isLegacyMarketingStarter250Portal = !!subscriptionTerms[_MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL];

    if (isMarketingStarter && isLegacyMarketingStarter250Portal) {
      return _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL;
    }

    var highlightedMerchToUse = isInMCBeta && hub === _Hubs.HUB_MARKETING ? _HubMap.default[hub].highlightedPaidMerchMCBeta : _HubMap.default[hub].highlightedPaidMerch;
    var merchIdForEdition = highlightedMerchToUse.find(function (merchId) {
      return merchandiseMap[merchId].edition === edition;
    });
    return merchIdForEdition;
  };
});
exports.getMerchIdForEditionSelector = getMerchIdForEditionSelector;

var isGrowthSuiteSelector = function isGrowthSuiteSelector(state, merchIds) {
  var _foundEditions;

  var merchandiseMap = merchandiseSelector(state);
  var foundEditions = (_foundEditions = {}, (0, _defineProperty2.default)(_foundEditions, _HubTypes.default.MARKETING, null), (0, _defineProperty2.default)(_foundEditions, _HubTypes.default.SALES, null), (0, _defineProperty2.default)(_foundEditions, _HubTypes.default.SERVICE, null), _foundEditions);
  merchIds.forEach(function (merchId) {
    var merch = merchandiseMap[merchId];

    if (merch.hubType in foundEditions && merch.edition) {
      foundEditions[merch.hubType] = merch.edition;
    }
  });
  var editionsAreSame = foundEditions[_HubTypes.default.MARKETING] !== null && foundEditions[_HubTypes.default.MARKETING] === foundEditions[_HubTypes.default.SALES] && foundEditions[_HubTypes.default.MARKETING] === foundEditions[_HubTypes.default.SERVICE];
  return editionsAreSame;
};

exports.isGrowthSuiteSelector = isGrowthSuiteSelector;

var baseMerchForAdditionalUnitSelector = function baseMerchForAdditionalUnitSelector(state, merchandiseId) {
  var merchandiseMap = merchandiseSelector(state);
  return Object.values(merchandiseMap).find(function (merchItem) {
    return merchItem.additionalUnitMerchId === merchandiseId;
  }) || null;
};

exports.baseMerchForAdditionalUnitSelector = baseMerchForAdditionalUnitSelector;

var merchUnitTypeSelector = function merchUnitTypeSelector(state, merchId) {
  var merchandiseMap = merchandiseSelector(state);
  if (!merchandiseMap) return null;
  var _merchandiseMap$merch = merchandiseMap[merchId],
      additionalUnitMerchId = _merchandiseMap$merch.additionalUnitMerchId,
      units = _merchandiseMap$merch.units;
  if (units) return units;
  return merchandiseMap[additionalUnitMerchId].units;
};

exports.merchUnitTypeSelector = merchUnitTypeSelector;

var merchandiseEditionSelector = function merchandiseEditionSelector(state, merchandiseId) {
  var merchandiseMap = merchandiseSelector(state);

  if (merchandiseMap[merchandiseId]) {
    return merchandiseMap[merchandiseId].edition;
  }

  return null;
};

exports.merchandiseEditionSelector = merchandiseEditionSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/MerchandiseSelectors.js
// module id = 23
// module chunks = 5 6 7